export const ADMIN_ONLY_ROUTE_META = {
  adminOnly: true,
} as const

export const RECRUITING_AI_ROUTE_META = {
  recruitingAiOnly: true,
} as const

export const ORGANIZATION_ROUTE_META = {
  requiresOrganization: true,
} as const

export const LOGTO_SCOPES = {
  adminRead: 'admin:read',
  adminWrite: 'admin:write',
  contactFetchPage: 'contact:fetch:page',
  contactFetchTag: 'contact:fetch:tag',
  reportExport: 'report:export',
  emailManage: 'email:manage',
  emailSend: 'email:send',
  emailInbox: 'email:inbox',
  emailOutreach: 'email:outreach',
  inmail: 'inmail',
  agent: 'agent',
  whatsapp: 'whatsapp',
} as const

export const hasAdminAccess = (canAdminRead: boolean) => canAdminRead

export const hasRecruitingAiAccess = (canAgent: boolean) => canAgent
